// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e98be40","455":"b461a86e","977":"c5770206"}[chunkId] + ".chunk.js";
};